import update from 'immutability-helper';

import {
   SET_NOTE_RANGE,
   TOGGLE_NOTE_SELECTED,
   TOGGLE_REFERENCE_PLAYING,
   PIANO_KEY_DOWN,
   TOGGLE_SELECTED_PLAYING,
   PIANO_KEY_UP,
   CLEAR_SELECTED_NOTES,
   SET_REFERENCE_NOTES,
   SET_SELECTED_NOTES,
   SET_LABELED_NOTES,
   SET_HIDDEN_CONTROLS,
   SET_CAN_PLAY_SELECTED_WITHOUT_COMPARE_ANSWER,
   STOP_PLAYING,
   SET_VIEW,
   SET_CHORD_INFO,
   SELECT_CHORD_INFO_VALUE,
} from './actions';
import {
   ADD_SOUND_KIT,
   SET_COMPARE_ANSWER,
   SET_HIGHLIGHTED_CONTROLS,
} from '../../shared/actions';
import { KEYBOARD_INTERFACE_TYPE } from '../interfaceTypes';

const notesFromRange = ([rangeLow, rangeHigh]) => {
   const notes = [];
   for (let i = rangeLow; i <= rangeHigh; i += 1) {
      notes.push(i);
   }
   return notes;
};

const keyboardReducer = (
   state = {
      type: KEYBOARD_INTERFACE_TYPE,
      compareAnswer: false,
      noteRange: [-21, 2],
      notes: notesFromRange([-21, 2]),
      referenceNotes: {},
      pressedNotes: {},
      selectedNotes: {},
      labeledNotes: {},
      highlightedControls: {},
      hiddenControls: {},
      referencePlaying: false,
      selectedPlaying: false,
      canPlaySelectedWithoutCompareAnswer: false,
      soundKit: {},
      userInstrument: 'keys',
      referenceInstrument: 'keys',
      view: 'keyboard',
      chordInfo: {},
   },
   action
) => {
   switch (action.type) {
      case SET_NOTE_RANGE:
         return {
            ...state,
            noteRange: action.noteRange,
            notes: notesFromRange(action.noteRange),
         };

      case SET_HIGHLIGHTED_CONTROLS:
         return { ...state, highlightedControls: action.highlightedControls };

      case SET_HIDDEN_CONTROLS:
         return { ...state, hiddenControls: action.hiddenControls };

      case TOGGLE_NOTE_SELECTED:
         return update(state, {
            selectedNotes: { $toggle: [action.note] },
         });

      case SET_SELECTED_NOTES:
         return { ...state, selectedNotes: action.notes };

      case CLEAR_SELECTED_NOTES:
         return { ...state, selectedNotes: {} };

      case SET_REFERENCE_NOTES:
         return { ...state, referenceNotes: action.notes };

      case SET_LABELED_NOTES:
         return { ...state, labeledNotes: action.notes };

      case TOGGLE_REFERENCE_PLAYING:
         return update(state, {
            $toggle: ['referencePlaying'],
            selectedPlaying: { $set: false },
         });

      case TOGGLE_SELECTED_PLAYING:
         return update(state, {
            $toggle: ['selectedPlaying'],
            referencePlaying: { $set: false },
         });

      case STOP_PLAYING:
         return update(state, {
            selectedPlaying: { $set: false },
            referencePlaying: { $set: false },
         });

      case SET_CAN_PLAY_SELECTED_WITHOUT_COMPARE_ANSWER:
         return {
            ...state,
            canPlaySelectedWithoutCompareAnswer:
               action.canPlaySelectedWithoutCompareAnswer,
         };

      case PIANO_KEY_DOWN: {
         return update(state, {
            referencePlaying: { $set: false },
            selectedPlaying: { $set: false },
            pressedNotes: { [action.note]: { $set: true } },
         });
      }

      case PIANO_KEY_UP: {
         return update(state, {
            pressedNotes: { [action.note]: { $set: false } },
         });
      }

      case ADD_SOUND_KIT:
         return {
            ...state,
            soundKit: action.soundKit,
         };

      case SET_COMPARE_ANSWER:
         return { ...state, compareAnswer: action.compareAnswer };

      case SET_VIEW:
         return { ...state, view: action.viewType };

      case SET_CHORD_INFO:
         return { ...state, chordInfo: action.info };

      case SELECT_CHORD_INFO_VALUE:
         return update(state, {
            chordInfo: {
               [action.key]: {
                  selected: {
                     $set: action.value,
                  },
               },
            },
         });

      default:
         return state;
   }
};

export { keyboardReducer };
